import { gql } from "@apollo/client";

export const REASONS = gql`
    query reasons($type: String, $page: String) {
        reasons(type: $type, page: $page) {
            id
            name
            type
            page
            is_actived
        }
    }
`;

export default REASONS;
